import { render, staticRenderFns } from "./ResourceCalendarHolidaysTab.vue?vue&type=template&id=11381be8&scoped=true"
import script from "./ResourceCalendarHolidaysTab.vue?vue&type=script&lang=js"
export * from "./ResourceCalendarHolidaysTab.vue?vue&type=script&lang=js"
import style0 from "./ResourceCalendarHolidaysTab.vue?vue&type=style&index=0&id=11381be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11381be8",
  null
  
)

export default component.exports